module.exports = __webpack_public_path__ + "static/media/collection.b3d67132.png";